module.exports = __webpack_public_path__ + "img/9305931.jpg";